

























import { computed, defineComponent, ref, useContext, useFetch, watch } from '@nuxtjs/composition-api'
import Spinner from '~/components/solepro/Spinner.vue';
import { useWishlistStore } from '~/modules/wishlist/store/wishlistStore';
import wishlistGetters from '~/modules/wishlist/getters/wishlistGetters';
import { useConfig, useWishlist } from '~/composables';
import axios from 'axios';
import CategoryPagination from '~/components/solepro/Category/Pagination/CategoryPagination.vue';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
//import { getProductTypeTag, getTopicTags } from '~/utils/solepro/products';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import { getProductTypeTag, getTopicTags } from '~/utils/solepro/products';
import EmptyBlock from './EmptyBlock.vue';
//import { productsMock } from '~/modules/catalog/category/components/views/__tests__/productsMock';

export default defineComponent({
    components: {
        PLPProductBox: () => import('~/components/solepro/PLPProductBox.vue'),
        CategoryPagination,
        Spinner,
        EmptyBlock
    },
    setup() {
        const { app } = useContext()
        const {
            load: loadWishlist,
            loading,
            removeItem,
            afterAddingWishlistItemToCart,
        } = useWishlist();
        const fetchLoadingCounter = ref(0)
        const fetchLoading = computed(()=>fetchLoadingCounter.value>0)
        const wishlistStore = useWishlistStore();
        const allCategories = ref([]);
        const products = ref([]);
        const categoryStore = useCategoryStore();
        const { config: storeConfig } = useConfig();

        const realProducts = computed(() => wishlistGetters.getProducts(wishlistStore.wishlist));
        const pagination = computed(() => wishlistGetters.getPagination(wishlistStore.wishlist));
        useFetch(async ()=>{
            fetchLoadingCounter.value++
            categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            await loadWishlist({ searchParams: { pageSize: 100 } });// @TODO
            fetchLoadingCounter.value--
        })
        const skus = computed(()=>(realProducts.value||[]).map(el=>el.product.sku))
        watch(skus, async(newValue)=>{
            if(newValue.length > 0 ){
                fetchLoadingCounter.value++
                const { data } = await axios.post('/sole-api/product/getProducts', {skus: newValue}, {...getAxiosConfigs(app, storeConfig)})
                products.value = data.map(el=>{
                return {
                   ...el,
                    topics: getTopicTags(allCategories.value, el) || [],
                    productTypeTag: getProductTypeTag(allCategories.value, el),
                    id: realProducts.value.find(w=>w.product.sku==el.sku).id
                }
            })
            setTimeout(()=>{
                fetchLoadingCounter.value--
            },500) 
            }else {
                products.value = []
            }
        })
       
        return {
            products,
            pagination,
            removeItem,
            storeCode: storeConfig.value.store_code,
            realProducts,
            loading: computed(()=>loading.value || fetchLoading.value)
        }
    },
    methods: {
        goToPage(page: number) {
            // @TODO implement pagination
            console.log('go to page', page);
        },
        removeFromWishlist(product) {
            // @ts-ignore
            this.removeItem({product});
        }
    }
})
